<template>
  <div>
    <div class="d-flex justify-content-between">
      <business-document-modal :business="initial_business" v-if="showDocumentModal" @onAdd="handleDocumentAdded" @close="showDocumentModal = false"></business-document-modal>
    <h3>Documents</h3>

    <el-button
      class="btn-light-blue"
      @click="showDocumentModal=true"
      type="primary"
      plain
    >Upload New</el-button>
    </div>


    <div class="row mt-2" v-for="(media, index) in medias" :key="index">
      <div class="col-12">
        <hr>
      </div>

      <div class="col-4"></div>
      <div class="col-5">
        <div class="row">
          <div class="col-12">
            <h6>{{media.id}} - {{media.name}}</h6>
          </div>
          <div class="col-6">{{_.startCase(_.replace(media.collection_name, '_', ' '))}}</div>

          <div
            class="col-12"
          >Uploaded: {{moment.utc(media.created_at, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}}</div>
        </div>
      </div>


      <div class="col-3">
        <el-tag
          class="status-pill"
          :type="getMediaStatus(media.media_status_id).tag_type"
        >{{getMediaStatus(media.media_status_id).name}}</el-tag>
      </div>
    </div>
  </div>
</template>
<script>
import MediaStatuses from "../../../../constants/MediaStatuses.js";

export default {
  props: {
    initial_business: Object
  },
  data() {
    return {
      //
      medias: this.initial_business.media,
      showDocumentModal:false,
    };
  },
  methods: {
    getMediaStatus(media_status_id) {
      let statuses = Object.keys(MediaStatuses).map(key => {
        return MediaStatuses[key];
      });

      return statuses.filter(x => x.id == media_status_id)[0];
    },
    handleDocumentAdded(document) {
      this.medias.unshift(document);
    }
  }
};
</script>